import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";







@Component({
  selector: "app-pricing",
  templateUrl: "./pricing.component.html",
  styleUrls: ["./pricing.component.scss"],
})


export class PricingComponent implements OnInit {

locations = [ 
{
  flag: '../../../assets/images/EGP.svg',
  label: 'Egypt',
  currency: 'EGP'
}, 

]

location = this.locations[0];

  showAdditionalFeatures = true;

  pricingFeatures = [{ id: 'price', name: '' },
  { id: 'dashboardKPIs', name: 'Dashboard KPIs' },
  { id: 'accounts', name: 'Accounts' },
  { id: 'permissionLevels', name: 'Permission levels​' },
  { id: 'confirmationEmailAddresses', name: 'Confirmation email addresses' },
  { id: 'paymentLinks', name: 'Payment Links' },
  { id: 'KIWECashlessSolution', name: 'KIWE cashless solution' },
  { id: 'firstTimeOnboardingAssistance', name: 'First time onboarding assistance' },
  { id: 'customizationRequests', name: 'Customization requests' },
  { id: 'automatedPaymentReminders', name: 'Automated payment reminders​' },
  { id: 'whiteLabeling', name: 'White labeling' },
  { id: 'integrations', name: 'Integrations with (LMS, SIS, ERP, etc.​)' },
  { id: 'popupAdsRemoved', name: 'Pop-up Ads removed ​' },]

  pricingPackages = [
    {
      name: 'Basic',
      price: '15',
      dashboardKPIs: 3,
      accounts: '1',
      permissionLevels: '1',
      confirmationEmailAddresses: 0,
      paymentLinks: false,
      KIWECashlessSolution: false,
      firstTimeOnboardingAssistance: false,
      customizationRequests: false,
      automatedPaymentReminders: false,
      whiteLabeling: false,
      integrations: false,
      popupAdsRemoved: false,
      bestValue: false,

      features: ['Dashboard Includes 3 KPIs', 'Payment reminders via email', '1 Permission level', '1 confirmation email address']
    },

    {
      name: 'Advanced',
      price: '60',
      dashboardKPIs: 6,
      accounts: 3,
      permissionLevels: 2,
      confirmationEmailAddresses: 2,
      paymentLinks: true,
      KIWECashlessSolution: true,
      firstTimeOnboardingAssistance: false,
      customizationRequests: false,
      automatedPaymentReminders: true,
      whiteLabeling: false,
      integrations: false,
      popupAdsRemoved: 
      true
      // 'Removing pop-up ads banner from school’s page'
      ,
      bestValue: false,

      features: ['Dashboard includes 6 KPIs', '2 Permission Levels', 'Payment reminders via email', 'Up to 2 confirmation email addresses', 'Payment links', 'KIWE (Cashless solution)'],
      additionalFeatures: ['Automating payment reminders',
        'Removing pop-up ads banner from school’s page',
        'Consolidated dashboard for entities with several branches']

    },

    {
      name: 'Premium',
      price: '100',
      dashboardKPIs: 10,
      accounts: 5,
      permissionLevels: 3,
      confirmationEmailAddresses: 4,
      paymentLinks: true,
      KIWECashlessSolution: true,
      firstTimeOnboardingAssistance: true,
      customizationRequests: 
      true
      // 'Limited to 40 hours/month'
      ,
      automatedPaymentReminders: true,
      whiteLabeling: false,
      integrations: false,
      popupAdsRemoved: true,
      bestValue: true,

      features: [' Dashboard Includes 10 KPIs',
        '3 Permission Levels',
        'Automated payment reminders via email',
        'Up to 4 confirmation email addresses',
        'Pop-up Ads automatically removed',
        'Payment links',
        'Customization Requests',
        'First time onboarding assistance',
        'Consolidated dashboard for entities with several branches',
        'KIWE (Cashless solution)'],

    },

    {
      name: 'Platinum',
      price: 'Starting 130 (RQ)',

      dashboardKPIs: 10,
      accounts: 5,
      permissionLevels: 3,
      confirmationEmailAddresses: 'Unlimited',
      paymentLinks: true,
      KIWECashlessSolution: true,
      firstTimeOnboardingAssistance: true,
      customizationRequests: true,
      automatedPaymentReminders: true,
      whiteLabeling: true,
      integrations: true,
      popupAdsRemoved: true,
      bestValue: false,

      features: ['Includes all premium features',
        'Integrations with other systems (LMS, SIS, ERP, etc)',
        'White Labelling',
        'Customization Requests',
        'Unlimited confirmation email addresses',
        'KIWE (Cashless solution)'],

    },
  ]

  displayedColumns: string[] = this.pricingPackages.map(x => x.name);
  dataSource = this.pricingFeatures.filter(x => x.id != 'price');


  selectedPlan=this.pricingPackages[2];

  constructor(

    private router: Router,

  ) { }

  print(e) {
    console.log(e)
  }

  goToSales() {
    this.router.navigate(["sales"]);
  }

  ngOnInit(): void {
this.location = this.locations[0];

   }
}
